// config.js

const bizIcon = 'https://content.app-sources.com/s/958222089685986121/uploads/Downloaded/The_Sky_Blue_Painting_LLC-3187790.png?format=webp';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://content.app-sources.com/s/958222089685986121/thumbnails/640x480/Downloaded/pfrm_expl_unsplsh-jo4CWjIw4Wc-3187632.webp?format=webp";
const imageTwo = "https://content.app-sources.com/s/958222089685986121/uploads/Images/334e55a6-a413-487a-b83c-c4fee6d2cd8e-0-2file_upload-Screenshot_20241129_001323_InShot-3739450.jpg?format=webp";
const imageThree = "https://content.app-sources.com/s/958222089685986121/uploads/Images/cc8954c0-9af6-4d98-b58e-20856546160d-0-2file_upload-InShot_20241128_234245838-3739451.jpg?format=webp";
const imageFour = "https://content.app-sources.com/s/958222089685986121/uploads/Images/334e55a6-a413-487a-b83c-c4fee6d2cd8e-0-2file_upload-Screenshot_20241129_001744_InShot-3739451.jpg?format=webp";
const imageFive = "https://content.app-sources.com/s/958222089685986121/uploads/Images/334e55a6-a413-487a-b83c-c4fee6d2cd8e-0-2file_upload-Screenshot_20241129_110623_Messenger-3739451.jpg?format=webp";

const redirectLink = "https://theskybluepaintingllc.com/";

export const siteConfig = {
  title: "The Sky Blue Painting LLC",
  metaDescription: "The Sky Blue Painting LLC",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-blue-600"
  },
  logo: {
    src: bizIcon,
    alt: "The Sky Blue Painting LLC Icon",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "The Sky Blue Painting LLC",
    headline: "Transforming Spaces with Expert Painting Solutions in Richmond, VA",
    address: "Fayetteville, NC",
    description: `
        The Sky Blue Painting LLC specializes in delivering high-quality painting services for residential and commercial properties in Richmond, VA. With a commitment to precision, professionalism, and customer satisfaction, our expert team transforms your spaces with stunning results. Whether it's refreshing interiors, enhancing exteriors, or custom painting projects, we bring your vision to life with a touch of excellence. Experience the art of painting with The Sky Blue Painting LLC.
    `,
  },
  images: {
    business: {
      src: imageOne,
      alt: "Transforming Spaces with Expert Painting Solutions in Richmond, VA",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
        description: 
          "Professional Painting Services: At The Sky Blue Painting LLC, we transform homes and businesses with expert painting solutions that enhance aesthetics and add value to your property.",
    },
    {
        description: 
          "Tailored to Your Vision: We work closely with clients to understand their unique style and preferences, delivering personalized painting services that bring their vision to life.",
    },
    {
        description: 
          "Flawless Finishes: With meticulous attention to detail, our team ensures every brushstroke contributes to a seamless, lasting finish that exceeds expectations.",
    },
  ],
  services: {
    sectionTitle: "Our Painting Services",
    description: 
      "The Sky Blue Painting LLC provides professional painting services to elevate the beauty and value of your property. Whether it’s a vibrant interior refresh or a durable exterior transformation, we ensure every project reflects your vision and stands the test of time. Based in Richmond, VA, we are committed to delivering high-quality results with precision and care.",
    callouts: [
        {
          name: 'Interior Painting Service',
          description: 
            "Transform your living spaces with our expert interior painting services. We use premium materials and meticulous techniques to create vibrant, long-lasting finishes that suit your style.",
          imageSrc: imageTwo,
          imageAlt: 'A freshly painted living room with vibrant colors and clean lines.',
        },
        {
          name: 'Exterior Painting Service',
          description: 
            "Give your property a striking new look with our exterior painting services. We protect and enhance your building’s facade with weather-resistant coatings and flawless finishes.",
          imageSrc: imageThree,
          imageAlt: 'A professional painter applying exterior paint on a residential home.',
        },
        {
          name: 'Rain Gutters Clean-Up',
          description: 
            "Complement your painting project with our gutter clean-up services. We ensure clean and functioning gutters, maintaining the integrity and appearance of your property.",
          imageSrc: imageFour,
          imageAlt: 'Professional gutter clean-up service ensuring spotless results.',
        },
    ]
  },
  about: {
    sectionTitle: "About Us",
    description:   
      "Welcome to The Sky Blue Painting LLC, where we transform spaces with professional painting services that inspire and impress. Based in Richmond, VA, we have earned a reputation for excellence and reliability, proudly serving our community with dedication and precision. Our team of skilled painters is committed to delivering results that reflect your unique vision, whether it’s refreshing an interior space or giving your property’s exterior a stunning new look.",
    image: {
      src: imageFive,
      alt: "The Sky Blue Painting LLC team delivering exceptional painting services in Richmond, VA.",
      width: 1200,
      height: 800,
    },
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "Richmond, Virginia, USA",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3133.1188538488877!2d-77.46053948465998!3d37.54072597979869!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b11123456789ab%3A0xfedcba987654321!2sRichmond%2C%20VA%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=Richmond,%20VA,%20USA',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=Richmond,+VA,+USA&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/Richmond,+VA,+USA/@37.540725,-77.460539,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/Richmond,+VA,+USA/@37.540725,-77.460539,15z',
      },
    ],  
  },
  contact: {
    sectionTitle: "Get in Touch with The Sky Blue Painting LLC",
    description: 
      "Enhance your property with the exceptional painting services of The Sky Blue Painting LLC in Richmond, VA. Whether it’s a vibrant interior refresh or a durable exterior finish, our skilled team is here to bring your vision to life. Contact us today for a free estimate or to schedule your painting service. Let’s make your property a masterpiece!",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: (804) 304-7904",
    ],
    logo: bizIcon,
    emailRecipient: "manueljesus4014@gmail.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


